import * as React from 'react'
import * as Reakit from 'reakit/Composite'

export const ListContext = React.createContext<Reakit.CompositeStateReturn | null>(null)

export function useListState(options?: Reakit.CompositeInitialState) {
  return Reakit.useCompositeState({ ...options, loop: true, unstable_virtual: true })
}
